import { render, staticRenderFns } from "./locdetail.vue?vue&type=template&id=550d7559&scoped=true"
import script from "./locdetail.vue?vue&type=script&lang=js"
export * from "./locdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550d7559",
  null
  
)

export default component.exports